import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Input, Row, Alert, Affix, Breadcrumb, Tabs } from 'antd';
import { observer } from 'mobx-react-lite';
import { QuestionCircleTwoTone } from '@ant-design/icons';

import QuickTurnPartStore from '../../../stores/QuickTurnPartStore';
import Pricing from 'components/QuickTurn/Pricing';
import PortalLoading from 'components/PortalLoading';
import Menu from 'components/QuickTurn/Menu';
import WelcomeModal from 'components/QuickTurn/WelcomeModal';
import ThreeJSCanvas from 'components/QuickTurn/ThreeJSCanvas';
import PartSpecificationForm from 'components/QuickTurn/PartSpecificationForm';
import { Link, useLocation } from 'react-router-dom';
import IconInputSliders from 'components/QuickTurn/Icons/IconInputSliders';
import IconDataTable from 'components/QuickTurn/Icons/IconDataTable';
import PartSummaryTable from 'components/QuickTurn/PartSummaryTable';
import IconInfo from 'components/QuickTurn/Icons/IconInfo';
import Features from 'components/QuickTurn/Features';
import QuickTurnProgramCapacityAlert from '../../../components/QuickTurn/QuickTurnProgramCapacityAlert';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const BuildPart = observer(() => {
    const params = useQuery();

    const template = params.get('template');

    async function fetchPart() {
        if (template) {
            await QuickTurnPartStore.startNewPart({
                template: template,
            });
            window.history.replaceState({}, document.title, window.location.pathname);
        } else {
            if (QuickTurnPartStore.partToken) {
                await QuickTurnPartStore.getPartByID(QuickTurnPartStore.partToken);
            } else {
                await QuickTurnPartStore.startNewPart();
            }
        }
    }

    useEffect(() => {
        fetchPart();
    }, []);

    return (
        <>
            <Menu title="Part Designer" />

            <div className="container">
                <div className="d-flex flex-row justify-content-between align-items-center w-100">
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <Link to="/quick-turn/design">QuickTurn</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>Part Designer</Breadcrumb.Item>
                    </Breadcrumb>

                    <div style={{ display: 'flex', alignItems: 'center', columnGap: '1rem' }}>
                        <Button
                            type="link"
                            style={{ padding: 0, margin: 0, height: '1rem' }}
                            className="text-dark underline"
                            size="small"
                            icon={<QuestionCircleTwoTone />}
                            onClick={() => QuickTurnPartStore.setTourModalVisible(true)}
                        >
                            Feature Tour
                        </Button>
                    </div>
                </div>
                <QuickTurnProgramCapacityAlert />

                {!QuickTurnPartStore.partToken || !QuickTurnPartStore.bufferGeometry ? (
                    <PortalLoading />
                ) : (
                    <>
                        <Row gutter={[16, 0]}>
                            <Col lg={16} span={24} className="mb-3">
                                <Affix>
                                    <ThreeJSCanvas showDimensions={true} />
                                </Affix>
                            </Col>
                            <Col lg={8} span={24}>
                                <Row className="mt-0">
                                    <Col span={24} md={{ order: 3 }} sm={{ order: 2 }}>
                                        <Tabs
                                            id="quickturn-part-designer-tabs"
                                            defaultActiveKey="1"
                                            style={{ position: 'relative' }}
                                            type="card"
                                            items={[
                                                {
                                                    key: '1',
                                                    label: (
                                                        <>
                                                            <IconInputSliders
                                                                size={20}
                                                                className="mr-2 d-sm-block d-none"
                                                            />
                                                            Dimensions
                                                        </>
                                                    ),
                                                    children: <PartSpecificationForm showInterestIndicators={true} />,
                                                },
                                                {
                                                    key: '2',
                                                    label: (
                                                        <>
                                                            <IconDataTable
                                                                size={20}
                                                                className="mr-2 d-sm-block d-none"
                                                            />
                                                            Summary
                                                        </>
                                                    ),
                                                    children: <PartSummaryTable />,
                                                },
                                                {
                                                    key: '3',
                                                    label: (
                                                        <>
                                                            <IconInfo size={18} className="mr-2 d-sm-block d-none" />
                                                            Features
                                                        </>
                                                    ),
                                                    children: <Features />,
                                                },
                                            ]}
                                        />
                                    </Col>

                                    {/* <Col span={24} md={{ order: 2 }} sm={{ order: 2 }}>
                                        <Card className="mb-2" bodyStyle={{ padding: '0.5rem' }}>
                                            <Row className="m-0 p-0">
                                                <Col span={6}>
                                                    <div className="d-flex flex-column align-items-center">
                                                        <IconDataTable size={48} />
                                                        <div>Summary</div>
                                                    </div>
                                                </Col>
                                                <Col span={6}>
                                                    <div className="d-flex flex-column align-items-center">
                                                        <IconCaliper size={48} />
                                                        <div>Dimensions</div>
                                                    </div>
                                                </Col>
                                                <Col span={6}>
                                                    <div className="d-flex flex-column align-items-center">
                                                        <IconInputSliders size={48} />
                                                        <div>Dimensions</div>
                                                    </div>
                                                </Col>
                                                <Col span={6}>
                                                    <div className="d-flex flex-column align-items-center">
                                                        <svg
                                                            width="48px"
                                                            height="48px"
                                                            version="1.1"
                                                            viewBox="0 0 1200 1200"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path d="m1077.9 513.39 51.637-51.617-133.78-205.91-88.238-88.781c-1.8008-1.9883-44.418-49.031-98.117-51-26.926-1.1641-51 8.9453-72.301 29.531l-13.723 13.254 74.773 74.773-12.188 12.188-74.418-74.418-13.258 12.992c-16.445 16.125-24.824 34.688-24.918 55.18-0.11328 21.73 9.2617 40.293 17.492 52.387l-174.39 174.39 24.469 24.469-363.63 363.68 46.949 46.949-87.469 87.469 26.512 26.512 87.469-87.469 46.949 46.949 363.64-363.64 19.352 19.352 163.78-163.78 165.04 114.96 56.211-56.23-159.34-159.34 12.188-12.188zm-270.02-359.85c37.668 1.293 71.383 38.195 72.395 39.301l85.105 85.125 116.14 178.8-3.6172 3.6172-146.08-146.08-153.38-153.39c9.2812-5.3047 18.766-7.7227 29.438-7.3672zm-510.17 768.36-67.387-67.387 33.375-33.375 37.164 37.164 26.512-26.512-37.164-37.164 31.875-31.875 37.164 37.164 26.512-26.512-37.164-37.164 31.875-31.875 37.164 37.164 26.512-26.512-37.164-37.164 31.875-31.875 37.164 37.164 26.512-26.512-37.164-37.164 31.875-31.875 37.164 37.164 26.512-26.512-37.164-37.164 43.688-43.688 29.023 29.023 154.78-154.78 10.539 10.539-154.8 154.78 27.824 27.824zm707.48-388.8-165.04-114.96-159.47 159.45-20.664-20.664 154.8-154.78-63.582-63.582-154.78 154.78-26.98-26.98 159.75-159.75 13.07-13.199-12.992-13.258c-0.11328-0.11328-10.445-10.742-15.617-25.199-3.75-10.445-3.8047-19.781-0.09375-28.52l299.1 299.1zm-125.32-193.37-67.387-67.387 12.188-12.188 67.387 67.387z" />
                                                        </svg>
                                                        <div>Dimensions</div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col> */}

                                    <Col span={24} md={{ order: 1 }} sm={{ order: 3 }}>
                                        <Card>
                                            <Pricing />
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <WelcomeModal />
                    </>
                )}
            </div>
        </>
    );
});

export default BuildPart;
